/** All region prefixes derived from: https://cloud.google.com/about/locations */
const regionPrefixes = ['us', 'northamerica', 'southamerica', 'europe', 'asia', 'australia', 'me'];

/** Extracts the region from a run name, i.e. 'us-central1' from 'careers-production-us-central1'. */
export function extractRegion(runName: string): string | undefined {
  const cluster = regionPrefixes.find(prefix => runName.includes(`-${prefix}-`));
  if (!cluster) return undefined;
  return runName.substring(1 + runName.indexOf(`-${cluster}-`));
}
